import { useState, useEffect, useContext } from 'react';
import { AuthFetch, AuthFetchOauth } from '../services/api';
import { notify, formatDate } from '../utils/utils';
import { useModal } from './useModal';
import { UserContext } from '../context/provider/UserProvider';

// TERMINADO

export const useOperaciones = () => { 
    
    const operacionDefault = {
        codUsuarioAccion: 0,
        listaDetallaMovimiento: [
            {
                monto: 0,
                codEntidadBancaria: 1
            }   
        ]
    }

    const [ isOpenModalResumenMonto, openModalResumenMonto, closeModalResumenMonto ] = useModal()
    const [ isOpenModalIncioOperacion, openModalInicioOperacion, closeModalInicioOperacion ] = useModal()
    const [ operaciones, setOperaciones ] = useState(); 
    const { stateUser , signOut } = useContext(UserContext);
    const [ operacion, setOperacion ] = useState(operacionDefault)
    const [ operacionActiva, setOperacionActiva ] = useState({isValid:false})  
    const [ resumenMontoOperaciones, setResumenMontoOperaciones ] = useState([])
    const [ fechaInicial, setFechaIncial ] = useState()
    const [ fechaFinal, setFechaFinal ] = useState()
    const [ movimientosRecargas, setMovimientosRecarga ] = useState([]);
    const [ detalleMovimientosRecargas, setDetalleMovimientosRecarga ] = useState([]);


    const listarOperaciones = async (fechaInicio, fechaFin) =>{
        setFechaIncial(fechaInicio)
        setFechaFinal(fechaFin)
        
        const response = await AuthFetch('/Operation?' + new URLSearchParams({
            fechaInicio:formatDate(fechaInicio,23),
            fechaFin:formatDate(fechaFin,23) ,
        }),{
            method : 'GET'
        })
        if (response.isValid){
            setOperaciones(response.content)
        }else{
            notify(response.exceptions[0].description,'error')
        } 
    }   

    const verificarInicioOperacion = async () =>{
        const response = await AuthFetch('/Operation/loginValidation?' + new URLSearchParams({
            uid:stateUser.uid ,
        }),{
            method : 'GET'
        })
        
        if (response.isValid){
            setOperacionActiva(response.content)
        }else{
            setOperacionActiva({isValid:false})
            notify(response.exceptions[0].description,'error')
        } 
        // para pruebas
        // setOperacionActiva({isValid:true})
        //borrarlo
    }   

    const listarResumenMontos = async (codOperacion) =>{
        const response = await AuthFetch('/Operation/summaryBankingEntities?' + new URLSearchParams({
            CodUsuarioOperacion: codOperacion,
        }),{
            method : 'GET'
        })
        if (response.isValid){
            setResumenMontoOperaciones(response.content)
            openModalResumenMonto()
        }else{
            setResumenMontoOperaciones([])
            notify(response.exceptions[0].description,"error")
        } 
    }

    const iniciarOperacion = async (operacionObj)=>{
        
        const response = await AuthFetch(`/Operation`, {
            method: 'POST',
            body: JSON.stringify(operacionObj),
        })
        if (response.isValid){
            notify(response.content,"success")
            closeModalInicioOperacion()
        }else{
            notify(response.exceptions[0].description,'error')
        }
        listarOperaciones(fechaInicial, fechaFinal)
    }

    const finalizarOperacion = async (codOperacion)=>{

        const response = await AuthFetch(`/Operation/closeOperation`, {
            method: 'POST',
            body: JSON.stringify({
                uidOperacion: codOperacion.toString(),
                uid: stateUser.uid
            }),
        })
        if (response.isValid){
            notify(response.content,"success")
            closeModalResumenMonto()
        }else{
            notify(response.exceptions[0].description,'error')
        }
        listarOperaciones(fechaInicial, fechaFinal)
    }

    const editarValorOperacion = (key,value) =>{
        setOperacion(operacion => {
            return {
                ...operacion,
                [key]: value
            }
        });
    }

    const listarMovimientosRecargas = async () => {
        try{
            const response = await AuthFetch('/Operation/listOfRechargeTransactions')
            setMovimientosRecarga(response.isValid ? response.content : [])
            !response.isValid && notify(response.exceptions[0].description, 'error')
        }
        catch(error){
            console.error('Error al listar los movimientos de recarga → ',error)
            setMovimientosRecarga([])
            notify('Error al listar los movimientos de recarga', 'error')
        }
    }

    const listarMovimientosRecargasDetalle = async (uid, codMovimientoTipo, codEstado, fechaInicio, fechaFin) => {
        try{
            const response = await AuthFetch('/Operation/rechargeTransactionsDetails?' + new URLSearchParams({
                    uid: uid,
                    codMovimientoTipo: codMovimientoTipo,
                    codEstado: codEstado,
                    fechaInicio: fechaInicio,
                    fechaFin: fechaFin
                })
            )
            setDetalleMovimientosRecarga(response.isValid ? response.content : [])
            !response.isValid && notify(response.exceptions[0].description, 'error')
        }
        catch(error){
            setDetalleMovimientosRecarga([])
            notify('Error al listar los movimientos de recarga', 'error')
        }
    }

    return {
        listarOperaciones,
        verificarInicioOperacion,
        operaciones,
        operacion,
        iniciarOperacion,
        finalizarOperacion,
        operacionActiva,
        resumenMontoOperaciones,
        isOpenModalResumenMonto ,
        closeModalResumenMonto,
        listarResumenMontos,
        isOpenModalIncioOperacion,
        openModalInicioOperacion,
        closeModalInicioOperacion,
        listarMovimientosRecargas,
        movimientosRecargas,
        listarMovimientosRecargasDetalle,
        detalleMovimientosRecargas

    };
}